(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luckey-entrance"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lr-entrance')) {
    customElements.define('lr-entrance', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('.lr-intro-dialog');
        this.video = this.querySelector('.lr-intro-video');
        this.playButton = this.querySelector('.lr-intro-play');
        this.soundButton = this.querySelector('.lr-intro-sound');
        this.enterButton = this.querySelector('.lr-intro-enter');
        this.status = this.querySelector('.lr-intro-status');
        this.source = this.video?.querySelector('source');
        if (!this.dialog || !this.video || !this.playButton || !this.soundButton || !this.enterButton || !this.status) return;
        this.controller = new AbortController();
        this.inEditor = this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.phoneSource = window.matchMedia('(max-width: 720px)').matches;
        this.touchDevice = this.phoneSource || window.matchMedia('(pointer: coarse)').matches;
        this.initialized = false;
        this.lastFocus = null;
        this.manuallyPaused = false;
        this.wantsPlayback = false;
        this.resumeAfterVisibility = false;
        this.requestVersion = 0;
        this.mediaFailed = false;
        this.playBlocked = false;
        this.audioBlocked = false;
        this.wasOpen = false;
        this.video.autoplay = false;
        this.video.loop = true;
        this.video.playsInline = true;
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.volume = 0.75;
        const listen = (target, event, handler) => target?.addEventListener(event, handler, {signal: this.controller.signal});
        listen(this.enterButton, 'click', () => this.closeIntro());
        listen(this.playButton, 'click', () => {
          if (this.video.paused || this.video.ended) {
            if (this.dataset.soundEnabled === 'true') {
              this.video.muted = false;
              this.audioBlocked = false;
            }
            void this.playIntro();
          }
          else {
            this.manuallyPaused = true;
            this.resumeAfterVisibility = false;
            this.pauseIntro();
          }
        });
        listen(this.soundButton, 'click', () => {
          this.audioBlocked = false;
          if (this.video.muted || this.video.paused || this.video.ended) {
            this.video.muted = false;
            this.video.volume = 0.75;
            void this.playIntro();
          } else {
            this.video.muted = true;
          }
          this.updateControls();
        });
        listen(this.video, 'playing', () => {
          if (!this.dialog.open || document.hidden || !this.wantsPlayback) this.video.pause();
          this.updateControls();
        });
        listen(this.video, 'pause', () => this.updateControls());
        listen(this.video, 'volumechange', () => this.updateControls());
        const mediaError = () => {
          this.mediaFailed = true;
          this.initialized = false;
          this.pauseIntro();
        };
        listen(this.video, 'error', mediaError);
        listen(this.source, 'error', mediaError);
        listen(this.dialog, 'cancel', () => {
          this.pauseIntro();
          this.video.muted = true;
        });
        listen(this.dialog, 'close', () => this.finishClose(true));
        listen(document, 'visibilitychange', () => {
          if (!this.dialog.open) return;
          if (document.hidden) {
            this.resumeAfterVisibility = this.wantsPlayback || !this.video.paused;
            this.pauseIntro();
          } else {
            const resume = this.resumeAfterVisibility;
            this.resumeAfterVisibility = false;
            if (resume && !this.manuallyPaused && !this.motionPreference.matches) void this.playIntro();
          }
        });
        listen(window, 'pagehide', () => {
          this.pauseIntro();
          this.video.muted = true;
        });
        listen(window, 'pageshow', event => {
          if (event.persisted && this.dialog.open && !this.manuallyPaused && !this.motionPreference.matches) void this.playIntro();
        });
        listen(this.motionPreference, 'change', event => {
          if (event.matches && this.dialog.open) {
            this.manuallyPaused = true;
            this.resumeAfterVisibility = false;
            this.pauseIntro();
          }
        });
        listen(window, 'hashchange', () => {
          if (location.hash === '#intro') this.openIntro();
          else if (this.dialog.open && location.hash && location.hash !== '#home') this.closeIntro();
        });
        listen(document, 'click', event => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || this.inEditor) return;
          const trigger = event.target instanceof Element ? event.target.closest('[data-lr-open-intro], [data-open-intro], a[href]') : null;
          if (!trigger) return;
          let replay = trigger.hasAttribute('data-lr-open-intro') || trigger.hasAttribute('data-open-intro');
          if (!replay && trigger instanceof HTMLAnchorElement) {
            const url = new URL(trigger.href, location.href);
            replay = url.origin === location.origin && url.pathname === location.pathname && url.hash === '#intro';
          }
          if (!replay) return;
          event.preventDefault();
          this.openIntro();
        });
        this.updateControls();
        if (!this.inEditor && (!location.hash || location.hash === '#home' || location.hash === '#intro')) this.openIntro();
      }

      disconnectedCallback() {
        if (!this.controller) return;
        this.pauseIntro();
        this.video.muted = true;
        this.controller.abort();
        this.controller = null;
        if (this.dialog.open) this.dialog.close();
        this.finishClose(false);
      }

      updateControls() {
        const playing = !this.video.paused && !this.video.ended;
        const words = this.dataset;
        this.playButton.textContent = this.mediaFailed ? words.retry : playing ? words.pause : words.play;
        this.playButton.setAttribute('aria-label', this.mediaFailed ? words.retryLabel : playing ? words.pauseLabel : words.playLabel);
        this.soundButton.textContent = this.video.muted ? words.tapForSound : words.soundOn;
        this.soundButton.setAttribute('data-needs-sound', String(this.video.muted));
        this.soundButton.setAttribute('aria-label', this.video.muted ? words.soundOnLabel : words.soundOffLabel);
        this.soundButton.setAttribute('aria-pressed', String(!this.video.muted));
        this.status.textContent = this.mediaFailed ? words.unavailable : this.playBlocked ? words.playBlocked : playing ? this.video.muted ? this.audioBlocked ? words.playingAudioBlocked : words.playingMuted : words.playingAudio : this.motionPreference.matches ? words.pausedMotion : words.paused;
      }

      pauseIntro() {
        this.requestVersion += 1;
        this.wantsPlayback = false;
        this.video.autoplay = false;
        this.video.pause();
        this.updateControls();
      }

      loadVideo() {
        if (this.initialized) return;
        const sourceUrl = (this.phoneSource ? this.source?.dataset.phone : this.source?.dataset.desktop) || this.source?.dataset.desktop || this.source?.dataset.phone;
        if (!sourceUrl) {
          this.mediaFailed = true;
          throw new Error('Missing intro video source');
        }
        this.source.src = sourceUrl;
        this.video.preload = 'auto';
        this.video.load();
        this.initialized = true;
      }

      async playIntro() {
        if (!this.dialog.open || document.hidden || this.inEditor) return;
        const request = ++this.requestVersion;
        this.manuallyPaused = false;
        this.wantsPlayback = true;
        this.video.autoplay = !this.motionPreference.matches;
        this.playBlocked = false;
        this.mediaFailed = false;
        const current = () => request === this.requestVersion && this.isConnected && this.dialog.open && !document.hidden && this.wantsPlayback;
        try {
          this.loadVideo();
          if (this.video.ended) this.video.currentTime = 0;
          await this.video.play();
        } catch (error) {
          if (!current()) return;
          if (!this.video.muted && !this.mediaFailed && error.name === 'NotAllowedError') {
            this.video.muted = true;
            this.audioBlocked = true;
            this.updateControls();
            try {
              await this.video.play();
            } catch {
              if (!current()) return;
              this.wantsPlayback = false;
              this.playBlocked = !this.mediaFailed;
            }
          } else {
            this.wantsPlayback = false;
            this.playBlocked = !this.mediaFailed;
          }
        }
        if (!this.isConnected || !this.dialog.open || document.hidden || !this.wantsPlayback) this.video.pause();
        this.updateControls();
      }

      openIntro() {
        if (this.dialog.open || this.inEditor || !this.isConnected) return;
        this.lastFocus = document.activeElement;
        this.pauseIntro();
        this.video.muted = this.touchDevice || this.dataset.soundEnabled !== 'true';
        this.video.volume = 0.75;
        this.audioBlocked = this.video.muted && this.dataset.soundEnabled === 'true';
        if (this.initialized) this.video.currentTime = 0;
        this.manuallyPaused = this.motionPreference.matches;
        this.resumeAfterVisibility = !this.motionPreference.matches && document.hidden;
        this.playBlocked = false;
        this.dialog.showModal();
        this.wasOpen = true;
        document.body.classList.add('lr-intro-active');
        this.dispatchEvent(new CustomEvent('lr:intro-open', {bubbles: true, detail: {sectionId: this.dataset.sectionId}}));
        this.enterButton.focus({preventScroll: true});
        this.updateControls();
        if (!this.motionPreference.matches && !document.hidden) void this.playIntro();
      }

      closeIntro() {
        this.pauseIntro();
        this.video.muted = true;
        this.dialog.close();
      }

      finishClose(restoreFocus) {
        this.pauseIntro();
        this.video.muted = true;
        this.resumeAfterVisibility = false;
        if (!document.querySelector('.lr-intro-dialog[open]')) document.body.classList.remove('lr-intro-active');
        if (!this.wasOpen) return;
        this.wasOpen = false;
        if (location.hash === '#intro') history.replaceState(null, '', location.pathname + location.search + '#home');
        document.dispatchEvent(new CustomEvent('lr:intro-close', {detail: {sectionId: this.dataset.sectionId}}));
        if (!restoreFocus || !this.isConnected || document.querySelector('dialog[open]')) return;
        if (this.lastFocus instanceof HTMLElement && this.lastFocus !== document.body && this.lastFocus.isConnected) {
          this.lastFocus.focus({preventScroll: true});
        } else {
          document.querySelector('[data-lr-intro-focus], .lr-header a[href*="/collections"], header a[href*="/collections"], header a[href], #MainContent')?.focus({preventScroll: true});
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luckey-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.lrHomeInitialized) return;
  window.lrHomeInitialized = true;
  const controllers = new WeakMap();
  const quoteUrl = 'https://app.shopmonkey.cloud/public/quote-request/c2117461-f6cd-4a69-8d0b-0ebf98144906';
  const quoteOrigin = 'https://app.shopmonkey.cloud';
  const init = (root) => {
    if (controllers.has(root)) return;
    const lifecycle = new AbortController();
    const signal = lifecycle.signal;
    const listen = (element, name, handler) => element?.addEventListener(name, handler, { signal });
    const images = Array.from(root.querySelectorAll('.lr-hero-image'));
    const sceneButtons = Array.from(root.querySelectorAll('[data-lr-scene]'));
    const motionButton = root.querySelector('.lr-motion-toggle');
    const dialog = root.querySelector('.lr-video-dialog');
    const player = root.querySelector('[data-lr-video-player]');
    const quoteFrame = root.querySelector('[data-lr-quote]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reducedMotion.matches;
    let introActive = document.body.classList.contains('lr-intro-active');
    let scene = 0;
    let timer;
    let observer;
    let opener;
    const showScene = (index) => {
      if (!Number.isInteger(index) || index < 0 || index >= images.length) return;
      scene = index;
      images[index].loading = 'eager';
      images.forEach((image, current) => image.classList.toggle('lr-active', current === index));
      sceneButtons.forEach((button, current) => {
        button.classList.toggle('lr-active', current === index);
        button.setAttribute('aria-pressed', String(current === index));
      });
    };
    const updateMotion = () => {
      window.clearInterval(timer);
      root.classList.toggle('lr-motion-paused', paused);
      if (motionButton) {
        motionButton.textContent = paused ? motionButton.dataset.play : motionButton.dataset.pause;
        motionButton.setAttribute('aria-pressed', String(paused));
        motionButton.setAttribute('aria-label', paused ? motionButton.dataset.resumeLabel : motionButton.dataset.pauseLabel);
      }
      if (!paused && !document.hidden && !dialog?.open && !introActive && !document.body.classList.contains('lr-intro-active')) {
        timer = window.setInterval(() => showScene((scene + 1) % images.length), 11000);
      }
    };
    sceneButtons.forEach((button) => listen(button, 'click', () => { showScene(Number(button.dataset.lrScene)); updateMotion(); }));
    listen(motionButton, 'click', () => { paused = !paused; updateMotion(); });
    listen(reducedMotion, 'change', (event) => { paused = event.matches; updateMotion(); });
    listen(document, 'visibilitychange', updateMotion);
    listen(document, 'lr:intro-open', () => { introActive = true; if (dialog?.open) dialog.close(); updateMotion(); });
    listen(document, 'lr:intro-close', () => { introActive = false; window.requestAnimationFrame(updateMotion); });
    listen(window, 'lr:intro-open', () => { introActive = true; if (dialog?.open) dialog.close(); updateMotion(); });
    listen(window, 'lr:intro-close', () => { introActive = false; window.requestAnimationFrame(updateMotion); });
    root.querySelectorAll('[data-lr-video]').forEach((button) => listen(button, 'click', () => {
      const id = button.dataset.lrVideo;
      if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
      const watchUrl = 'https://www.youtube.com/watch?v=' + id;
      if (!dialog || typeof dialog.showModal !== 'function') { window.open(watchUrl, '_blank', 'noopener'); return; }
      opener = button;
      root.querySelector('[data-lr-video-title]').textContent = button.dataset.title;
      root.querySelector('[data-lr-youtube-link]').href = watchUrl;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      frame.title = button.dataset.title;
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      player.replaceChildren(frame);
      if (!dialog.open) dialog.showModal();
      document.dispatchEvent(new CustomEvent('lr:video-open'));
      updateMotion();
    }));
    listen(root.querySelector('[data-lr-close]'), 'click', () => dialog.close());
    listen(dialog, 'close', () => {
      player.replaceChildren();
      document.dispatchEvent(new CustomEvent('lr:video-close'));
      if (opener?.isConnected && !document.body.classList.contains('lr-intro-active')) opener.focus();
      updateMotion();
    });
    listen(dialog, 'click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    listen(root.querySelector('[data-lr-collection-select]'), 'change', (event) => {
      if (!event.target.value) return;
      const target = new URL(event.target.value, window.location.origin);
      if (target.origin === window.location.origin) window.location.assign(target.href);
    });
    const loadQuote = () => {
      if (!quoteFrame || quoteFrame.dataset.src !== quoteUrl) return;
      if (quoteFrame.getAttribute('src') !== quoteUrl) quoteFrame.src = quoteUrl;
      observer?.disconnect();
    };
    if (quoteFrame) {
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => { if (entries.some((entry) => entry.isIntersecting)) loadQuote(); }, { rootMargin: '500px' });
        observer.observe(quoteFrame);
      } else loadQuote();
      if (window.location.hash === '#request') loadQuote();
    }
    listen(window, 'hashchange', () => { if (window.location.hash === '#request') loadQuote(); });
    listen(window, 'message', (event) => {
      if (!quoteFrame || event.origin !== quoteOrigin || event.source !== quoteFrame.contentWindow) return;
      if (!event.data || typeof event.data !== 'object' || Array.isArray(event.data) || event.data.source !== 'sm_wrf') return;
      if (!event.data.dataLayer || typeof event.data.dataLayer !== 'object' || Array.isArray(event.data.dataLayer)) return;
      if (!window.dataLayer) window.dataLayer = [];
      if (typeof window.dataLayer.push === 'function') window.dataLayer.push(event.data.dataLayer);
    });
    controllers.set(root, () => {
      lifecycle.abort();
      window.clearInterval(timer);
      observer?.disconnect();
      if (dialog?.open) dialog.close();
      player?.replaceChildren();
      controllers.delete(root);
    });
    updateMotion();
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-lr-home]')) init(scope);
    scope.querySelectorAll?.('[data-lr-home]').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-lr-home]').forEach((root) => controllers.get(root)?.());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luckey-music"]) return;
  try {
    
  if (!customElements.get('lr-background-music')) {
    customElements.define('lr-background-music', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.audio = this.querySelector('audio');
        this.button = this.querySelector('button');
        this.stateLabel = this.querySelector('.lr-music-state');
        if (!this.audio || !this.button || !this.stateLabel) return;
        this.controller = new AbortController();
        this.preferenceKey = 'lr-background-music-choice-v1';
        this.positionKey = 'lr-background-music-position-v1';
        this.pending = false;
        this.failed = false;
        this.generation = 0;
        this.lastSave = 0;
        this.wantsPlayback = this.readPreference() !== 'off' && this.dataset.autoplay === 'true' && !window.Shopify?.designMode;
        this.audio.volume = Math.max(0, Math.min(1, Number(this.dataset.volume || 25) / 100));
        const listen = (target, event, handler) => target.addEventListener(event, handler, {signal:this.controller.signal});
        listen(this.button, 'click', () => {
          if (this.wantsPlayback && (this.pending || !this.audio.paused)) {
            this.wantsPlayback = false;
            this.savePreference('off');
            this.stop();
          } else {
            this.wantsPlayback = true;
            this.savePreference('on');
            if (this.failed) {
              this.failed = false;
              this.audio.load();
            }
            this.start();
          }
        });
        listen(this.audio, 'loadedmetadata', () => this.restorePosition());
        listen(this.audio, 'playing', () => {
          if (!this.allowed()) this.stop();
          this.update();
        });
        listen(this.audio, 'pause', () => this.update());
        listen(this.audio, 'error', () => {
          this.failed = true;
          this.pending = false;
          this.update();
        });
        listen(this.audio, 'timeupdate', () => {
          if (Date.now() - this.lastSave > 1000) this.savePosition();
        });
        listen(document, 'click', event => {
          if (!event.isTrusted || event.defaultPrevented || event.button !== 0) return;
          if (event.target instanceof Element && event.target.closest('lr-background-music,[data-lr-open-intro],[data-open-intro],a[href="#intro"]')) return;
          if (this.wantsPlayback && this.audio.paused && !this.failed) this.start();
        });
        listen(document, 'lr:intro-open', () => this.stop());
        listen(document, 'lr:intro-close', () => this.start());
        listen(document, 'visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        });
        listen(window, 'pagehide', () => this.stop());
        listen(window, 'pageshow', () => this.start());
        listen(window, 'storage', event => {
          if (event.key === this.preferenceKey && event.newValue === 'off') {
            this.wantsPlayback = false;
            this.stop();
          }
        });
        this.hidden = false;
        this.update();
        this.start();
      }
      readPreference() {
        try { return localStorage.getItem(this.preferenceKey); } catch { return null; }
      }
      savePreference(value) {
        try { localStorage.setItem(this.preferenceKey, value); } catch {}
      }
      allowed() {
        return this.isConnected && this.wantsPlayback && !document.hidden && !document.querySelector('.lr-intro-dialog[open]');
      }
      async start() {
        if (!this.allowed() || this.pending || !this.audio.paused || this.failed) return;
        const generation = ++this.generation;
        this.pending = true;
        try {
          await this.audio.play();
          if (generation !== this.generation || !this.allowed()) this.audio.pause();
        } catch (error) {
          if (generation === this.generation && error.name !== 'NotAllowedError' && error.name !== 'AbortError') this.failed = true;
        } finally {
          if (generation === this.generation) this.pending = false;
          this.update();
        }
      }
      stop() {
        this.generation++;
        this.pending = false;
        this.savePosition();
        this.audio.pause();
        this.update();
      }
      savePosition() {
        if (!this.audio || !Number.isFinite(this.audio.duration)) return;
        this.lastSave = Date.now();
        try { sessionStorage.setItem(this.positionKey, JSON.stringify({src:this.audio.src,time:this.audio.currentTime})); } catch {}
      }
      restorePosition() {
        try {
          const position = JSON.parse(sessionStorage.getItem(this.positionKey));
          if (position?.src === this.audio.src && Number.isFinite(position.time) && position.time > 0 && Number.isFinite(this.audio.duration)) {
            this.audio.currentTime = Math.min(position.time, Math.max(0, this.audio.duration - 0.1));
          }
        } catch {}
      }
      update() {
        const playing = !this.audio.paused && !this.audio.ended && !this.failed;
        this.dataset.playing = String(playing);
        this.button.setAttribute('aria-pressed', String(playing));
        this.button.setAttribute('aria-label', playing ? this.dataset.pause : this.failed ? this.dataset.retry : this.dataset.play);
        this.stateLabel.textContent = this.failed ? this.dataset.retry : playing ? this.dataset.on : this.dataset.off;
      }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luckey-shell-header"]) return;
  try {
    
if (!customElements.get('lr-shell-header')) {
  customElements.define('lr-shell-header', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobile = this.querySelector('.lr-shell-mobile');
      this.toggle = this.mobile.querySelector('.lr-shell-menu-toggle');
      this.drawer = this.querySelector('.lr-shell-drawer');
      this.dropdowns = [...this.querySelectorAll('.lr-shell-dropdown')];
      this.mobile.addEventListener('toggle', () => {
        this.toggle.setAttribute('aria-expanded', String(this.mobile.open));
        document.body.classList.toggle('lr-shell-menu-open', this.mobile.open);
        if (this.mobile.open) this.setDrawerHeight();
      }, { signal });
      this.dropdowns.forEach((dropdown) => dropdown.addEventListener('toggle', () => {
        if (dropdown.open) this.dropdowns.forEach((other) => { if (other !== dropdown) other.open = false; });
      }, { signal }));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeMenus(false);
        else if (event.target.closest('a')) this.closeMenus(false);
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const wasMobileOpen = this.mobile.open;
          const focusedDropdown = this.dropdowns.find((dropdown) => dropdown.open && dropdown.contains(document.activeElement));
          this.closeMenus(wasMobileOpen);
          if (!wasMobileOpen) focusedDropdown?.querySelector('summary')?.focus();
          return;
        }
        if (event.key !== 'Tab' || !this.mobile.open) return;
        const focusable = [this.toggle, ...this.drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), summary, [tabindex="0"]')]
          .filter((element) => element.getClientRects().length > 0 && !element.closest('[hidden]'));
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }, { signal });
      window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 1200px)').matches) this.closeMenus(false);
        else if (this.mobile.open) this.setDrawerHeight();
      }, { signal });
      window.addEventListener('pagehide', () => this.closeMenus(false), { signal });
    }
    setDrawerHeight() {
      const bottom = this.querySelector('.lr-shell-header').getBoundingClientRect().bottom;
      const dockHeight = this.querySelector('.lr-shell-dock').getBoundingClientRect().height;
      this.drawer.style.setProperty('--lr-shell-drawer-height', `${Math.max(100, window.innerHeight - bottom - dockHeight)}px`);
    }
    closeMenus(restoreFocus) {
      this.mobile.open = false;
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lr-shell-menu-open');
      this.dropdowns.forEach((dropdown) => { dropdown.open = false; });
      if (restoreFocus) this.toggle.focus();
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.body.classList.remove('lr-shell-menu-open');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
